// extracted by mini-css-extract-plugin
export default {"input":"input_validation_input__b1oiA","inp_label_container":"input_validation_inp_label_container__94i4q","error":"input_validation_error__CsOrl"};